module.exports = __webpack_public_path__ + "img/b4-2.040aad4.png";